import React from 'react';
import './ImageComponent.css'

function ImageComponent(props) {
  return (
    <div className='expImage__container'>
      <img className='exp__image img__anim'  src={props.techImage} alt='expImg'/>
      <div className='expH1__container'>
        <h5 className='img__title'>{props.exptitle}</h5>
      </div>
    </div>
  )
}

export default ImageComponent